import Image from '@tiptap/extension-image';

// TODO: Image resize (deferred) — evaluate tiptap-extension-resize-image when required.
// See tasks/current-story.md — Deferred: Image resize.

/** Image extension configured for the rich-text editor. Upload is handled by useImagePaste hook. */
export function buildImageUploadExtension() {
  return Image.configure({
    inline: false,
    allowBase64: false,
    HTMLAttributes: {
      class: 'rich-text-image',
    },
  });
}
